/* js/components/mediaPlayers/DailyMotion.svelte generated by Svelte v3.46.4 */
import {
	HtmlTag,
	SvelteComponent,
	detach,
	empty,
	init,
	insert,
	noop,
	safe_not_equal
} from "svelte/internal";

import { onMount } from 'svelte';
import fetchJsonP from 'fetch-jsonp';

function create_if_block(ctx) {
	let html_tag;
	let html_anchor;

	return {
		c() {
			html_tag = new HtmlTag();
			html_anchor = empty();
			html_tag.a = html_anchor;
		},
		m(target, anchor) {
			html_tag.m(/*htmlContent*/ ctx[0], target, anchor);
			insert(target, html_anchor, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*htmlContent*/ 1) html_tag.p(/*htmlContent*/ ctx[0]);
		},
		d(detaching) {
			if (detaching) detach(html_anchor);
			if (detaching) html_tag.d();
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let if_block = /*htmlContent*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, [dirty]) {
			if (/*htmlContent*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { videoUrl } = $$props;
	let htmlContent = null;

	onMount(async () => {
		const url = `https://www.dailymotion.com/services/oembed?url=${videoUrl}`;

		try {
			// const fetchOptions = {
			//     mode: 'no-cors',
			// };
			// const response = await fetch(url, fetchOptions);
			const response = await fetchJsonP(url);

			const resp = await response.json();
			$$invalidate(0, htmlContent = resp.html);
			console.log("resp", resp);
		} catch(e) {
			console.error("dailmotion oembed fetch error", e);
		}
	});

	$$self.$$set = $$props => {
		if ('videoUrl' in $$props) $$invalidate(1, videoUrl = $$props.videoUrl);
	};

	return [htmlContent, videoUrl];
}

class DailyMotion extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { videoUrl: 1 });
	}
}

export default DailyMotion;